import { Link } from "react-router-dom";
import { content } from "../i18n/content";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer className="bg-[#1e1b1b] text-[#f9f6f0] py-16 sm:py-20" data-testid="main-footer">
    <div className="max-w-[1500px] mx-auto px-6 sm:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 pb-12 border-b border-[#f9f6f0]/10">
        <div>
          <button
            onClick={() => scrollToId("hero")}
            className="font-display text-4xl sm:text-5xl font-medium tracking-tight"
            data-testid="footer-brand"
          >
            {content.nav.brand}
            <span className="text-[#c86f53]">.</span>
          </button>
          <p className="mt-4 text-sm text-[#d4cfc7]/80 font-light" data-testid="footer-tagline">
            {content.footer.lineDe}
          </p>
          <p className="font-display italic text-lg text-[#c86f53]/90 font-light">{content.footer.lineEn}</p>
        </div>
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#d4cfc7]/60" data-testid="footer-location">
          {content.footer.location}
        </p>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row justify-between gap-4 text-[10px] uppercase tracking-[0.25em] text-[#d4cfc7]/50">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Englisch in Wandsbek — {content.footer.rights}</p>
        <div className="flex items-center gap-6">
          <Link to="/impressum" className="hover:text-[#c86f53] transition-colors duration-300" data-testid="footer-impressum-link">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-[#c86f53] transition-colors duration-300" data-testid="footer-datenschutz-link">
            Datenschutz
          </Link>
          <p data-testid="footer-languages">Deutsch · English</p>
        </div>
      </div>
    </div>
  </footer>
);
